import ENV from "glesys-controlpanel/config/environment";
import ApplicationSerializer from "./application";
import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";

export default class ServerSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  usesProxy = true;

  primaryKey = "serverid";

  attrs = {
    backup: { serialize: false },
    hasManagedHosting: "managedhosting",
    ips: { embedded: "always", key: "iplist" },
    project: "projectkey",
    transfer: { serialize: false },
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.iplist = Object.values(resourceHash.iplist).map((ip) => ({
      ...ip,
      project: resourceHash.projectkey,
      server: resourceHash.serverid,
    }));

    if (resourceHash.backup) {
      resourceHash.backup.enabled = resourceHash.backup.enabled === "yes";
    }

    resourceHash.links = {
      networkAdapters: `${ENV.apiBaseUri}/server/networkadapters?serverid=${resourceHash.serverid}`,
      backups: `${ENV.apiBaseUri}/server/listbackups?serverid=${resourceHash.serverid}`,
      costs: `${ENV.apiBaseUri}/server/costs?serverid=${resourceHash.serverid}`,
      status: `${ENV.apiBaseUri}/server/status?serverid=${resourceHash.serverid}`,
      platformArguments: `${ENV.apiBaseUri}/server/allowedarguments?projectkey=${resourceHash.projectkey}&serverid=${resourceHash.serverid}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }

  normalizeDeleteRecordResponse() {
    return { data: null };
  }

  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);

    if (snapshot.record.isNew) {
      if (!json.users?.length) {
        delete json.users;
      }

      if (!json.backupschedules?.length) {
        delete json.backupschedules;
      }
    }

    if (!snapshot.record.isNew) {
      delete json.bandwidth;

      if (!snapshot.changedAttributes().backupschedules) {
        delete json.backupschedules;
      }
    }

    return json;
  }
}
